import React from "react";
import {
	AutocompleteInput,
	ReferenceInput,
	required,
	SelectInput,
	SimpleForm,



	useDataProvider, useTranslate
} from "react-admin";
import { useForm } from "react-final-form";
import { bookmakersConfig } from "../bookmakers";
import EventSelectInput from "./inputs/EventSelectInput";
import ItemsInput from "./inputs/ItemsInput";

const BookmakerInput = ({ className, ...props }) => {
	const translate = useTranslate();
	const dataProvider = useDataProvider();
	const form = useForm();

	return (
		<ReferenceInput
			{...props}
			source="bookmaker_id"
			reference="bookmakers"
			fullWidth
			{...bookmakersConfig.reference}
			onChange={value => {
				if (value) {
					dataProvider.getOne("bookmakers", { id: value }).then(({ data }) => {
						form.batch(() => {
							form.change("bookmaker_type_id", data.bookmaker_type_id);
						});
					});
				}
			}}
			resettable
		>
			<AutocompleteInput
				optionText="name"
				emptyText={translate(
					"resources.bookmaker-deals.fields.bookmaker.all"
				)}
			/>
		</ReferenceInput>
	);
}

const Form = (props) => {
	const translate = useTranslate();
	return (
		<SimpleForm
			{...props}
			redirect="list"
			initialValues={{ items: [{ amount: null, to_value: null }] }}
		>
			<ReferenceInput
				source="bookmaker_type_id"
				reference="bookmaker-types"
				fullWidth
				resettable
			>
				<SelectInput
					optionText="name"
					emptyText={translate(
						"resources.bookmaker-deals.fields.bookmaker_type.all"
					)}
				/>
			</ReferenceInput>
			<BookmakerInput />
			<ReferenceInput
				source="user_id"
				reference="users"
				fullWidth
				resettable
				allowEmpty
			>
				<AutocompleteInput
					optionText="name"
					emptyText={translate("resources.bookmaker-deals.fields.users.all")}
				/>
			</ReferenceInput>
			<EventSelectInput source="event_id" validate={required()} />
			<ItemsInput source="items" fullWidth />
		</SimpleForm>
	);
};
export default Form;
